import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { SystemService } from '@frontend-site/shared/core';
import { Observable } from 'rxjs';
import { VOID } from '@frontend-site/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class SettingsResolver  {
    constructor(private systemService: SystemService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<void> {
        this.systemService.loadSystemsDetails();
        return VOID;
    }
}
